import apiClient from "./config";
import FormDataApiClient from "./formConfig";
import { PROFILE_ENDPOINTS } from "./endpoints";

const profileService = {
  // View Profile
  viewProfile: () => {
    return apiClient.get(PROFILE_ENDPOINTS.VIEWPROFILE);
  },
  listRoles: () => {
    return apiClient.get(PROFILE_ENDPOINTS.LISTROLES);
  },
  listExperience: () => {
    return apiClient.get(PROFILE_ENDPOINTS.LISTEXPERIENCE);
  },
  listLocationChoice: () => {
    return apiClient.get(PROFILE_ENDPOINTS.LISTLOCATIONCHOICE);
  },
  listState: () => {
    return apiClient.get(PROFILE_ENDPOINTS.LISTSTATE);
  },
  listCity: (params) => {
    return apiClient.get(PROFILE_ENDPOINTS.LISTCITY, { params });
  },
  updateProfile: (payload) => {
    return FormDataApiClient.post(PROFILE_ENDPOINTS.UPDATEPROFILE, payload);
  },
  uploadCrtDocument: (payload) => {
    return FormDataApiClient.post(PROFILE_ENDPOINTS.UPLOADCERTDOCUMENT, payload);
  },
};

export default profileService;
